/* eslint-disable import/first */
import './public-path'; // Don't try to re-order this, it needs to be imported before any other modules
import React from 'react';
import ReactDOM from 'react-dom';
import { getCldrLocale, setupI18nModel } from '@bingads-webui/i18n-model-setup';
import { PageReady } from '@bingads-webui/page-ready';
import { initGlobalService, PROJECTS } from '@bingads-webui-campaign/global-app-init';
import { getInstrumentation, surveySchema } from '@bingads-webui-campaign-react/pmax-lite-instrumentation';
import { PerfMarkerFactory } from '@bingads-webui/performance-marker';

import { loadOneDSAnalytics } from './1DSAnalytics/1DS-Analytics';
import './index.less';
import { signUpIdpSelectionUrl, signInIdpSelectionUrl, userInvitationIdpSelectionUrl, emailExistsErrorUrl, loginErrorUrl } from './path';

// This marker would be used to track the pre app start latency.
// Any regression in this latency would impact all landing pages.
window.performance.preAppStartMarker = {
  eventName: 'ActivityMarker/AppStart.BeforeLoad',
  eventStartTime: window.performance.now(),
  activeTimeBeforeEventStart: window.performance.activeTime(),
};

const { serverContext } = window;
delete window.serverContext;

const locale = serverContext.CurrentLocale || document.documentElement.lang;

const cldrLocale = getCldrLocale(locale);

const devConfig = window.devConfig || {
  isInDevelopmentMode: false,
};

const instrumentation = getInstrumentation({
  serverContext,
  devConfig,
  subSystemName: 'pmax-lite-landing',
});

instrumentation.addScenario(surveySchema);

const appScenario = instrumentation.appScenario.create();
const appActivity = appScenario.appActivity.create();

if (window.performance.preAppStartMarker) {
  appActivity.perf(window.performance.preAppStartMarker);
  delete window.performance.preAppStartMarker;
}

let perfMarkerName = 'ShellPage_PmaxLiteLandingUI';
if (window.location.pathname === signUpIdpSelectionUrl) {
  perfMarkerName = 'ShellPage_PmaxLiteLandingUI_SignUpIdpPage';
} else if (window.location.pathname === signInIdpSelectionUrl) {
  perfMarkerName = 'ShellPage_PmaxLiteLandingUI_SignInIdpPage';
} else if (window.location.pathname === emailExistsErrorUrl) {
  perfMarkerName = 'ShellPage_PmaxLiteLandingUI_EmailExistsPage';
} else if (window.location.pathname === userInvitationIdpSelectionUrl) {
  perfMarkerName = 'ShellPage_PmaxLiteLandingUI_UserInvitationIdpPage';
} else if (window.location.pathname === loginErrorUrl) {
  perfMarkerName = 'ShellPage_PmaxLiteLandingUI_LoginErrorPage';
}

const appPerfMarker = PerfMarkerFactory.createMarker(perfMarkerName);
appPerfMarker.willInit();

initGlobalService({
  featureName: PROJECTS.PMAX_LITE_LANDING,
  serverContext,
  shouldLoad1DS: false, // will load 1DS separately
  shouldEnableUnAuth: true,
  shouldLoadAmplifyTracking: true,
  setUpClarityBasedOnUserConsent: true,
});

loadOneDSAnalytics({ serverContext });

import(/* webpackChunkName: "cldr-[request]" */`@bingads-webui-universal/i18n-cldr-data-modern/locales/${cldrLocale}.json`)
  .then(setupI18nModel(locale))
  .then(() => {
    PageReady.pageIsReady();

    // eslint-disable-next-line global-require
    const AppRoot = require('./app').default;

    ReactDOM.render(<AppRoot
      serverContext={serverContext}
      instrumentation={instrumentation}
      appPerfMarker={appPerfMarker}
    />, document.getElementById('root'));
  });
